import {
  missionCompletedFlag,
  type MissionDefinition,
} from '@/gameplay/Mission';
import { PROLOGUE_MISSION_ID } from '@/gameplay/missions/prologue';

export const SURVIVORS_MISSION_ID = 'na-01-overlevenden';

export const SURVIVORS_MISSION: MissionDefinition = {
  id: SURVIVORS_MISSION_ID,
  title: 'Overlevenden',
  act: 1,
  prerequisites: [
    { flag: missionCompletedFlag(PROLOGUE_MISSION_ID) },
  ],
  beats: [
    {
      id: 'setup',
      kind: 'setup',
      title: 'De kade na de aanval',
      objective: 'Regain control at the harbor safehouse',
      setup: 'Barili soldiers hit the docks before dawn; Luca starts with whoever survived.',
    },
    {
      id: 'street-objective',
      kind: 'streetObjective',
      title: 'Zoek de mannen',
      objective: 'Find three loyal soldiers in the harbor',
      trigger: 'Follower pickup radius around each loyal soldier.',
    },
    {
      id: 'human-beat',
      kind: 'humanBeat',
      title: 'Niemand laat je liggen',
      objective: 'Keep the soldiers close while they regroup',
      onEnter: 'The followers attach to Luca and form the first loyal squad.',
    },
    {
      id: 'complication',
      kind: 'complication',
      title: 'Barili patrouilles',
      objective: 'Avoid or defeat Barili patrols between the docks and the safehouse',
      trigger: 'Enemy FOV, line-of-sight and combat systems.',
    },
    {
      id: 'choice-or-consequence',
      kind: 'choiceOrConsequence',
      title: 'Iedereen mee',
      objective: 'If a loyal soldier goes down, the mission fails',
      onComplete: 'Survivors become Luca followers for the rest of the chapter.',
    },
    {
      id: 'reward',
      kind: 'reward',
      title: 'Terug naar binnen',
      objective: 'Escort all survivors into the safehouse',
      onComplete: 'Vitale morale stabilizes after the opening attack.',
    },
  ],
  rewards: {
    flags: {
      [missionCompletedFlag(SURVIVORS_MISSION_ID)]: true,
      'act1.survivorsSecured': true,
    },
    reputation: {
      populace: 2,
      rivals: -2,
    },
  },
};
